import config from "@/config"
import http from "@/utils/request"

export default {
	add: {
		url: `${config.API_URL}/deviceCheck/`,
		name: "添加设备质检记录",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/deviceCheck/`,
		name: "删除设备质检记录", 
		delete: async function(id,data){
			return await http.delete(this.url+id+"/", data);
		}
	},
    detail: {
		url: `${config.API_URL}/deviceCheck/`,
		name: "查询设备质检记录详情",
		get: async function(id,data){
			return await http.get(this.url+id+"/", data);
		}
	},
    list: {
		url: `${config.API_URL}/deviceCheck/`,
		name: "查询设备质检记录列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
}